import { useMediaQuery, useTheme } from '@mui/material';

/** lg(1200px) and up: drawer + center + right column layout */
export const useMainLayout = () => {
  const theme = useTheme();
  const isDesktopLayout = useMediaQuery(theme.breakpoints.up('lg'));

  return { isDesktopLayout };
};
